// Predicado ÚNICO de "por pagar" a nivel FACTURA SII recibida (regla 10.1 / 10.106).
//
// Fuente de verdad compartida entre FlujoCajaV2 (panel "Por pagar" + badge
// countPorPagarPendientes) y EstadoCuenta (contador de facturas por pagar por proveedor).
// Antes vivía inline en FlujoCajaV2 y estaba DUPLICADO inline en EstadoCuenta (Fase 3);
// se consolidó acá (Fase 4) para que ambos no puedan divergir ante un nuevo gate.
//
// NO gatea por estado_vinculacion (regla 10.65): una factura "vinculada" pagada solo
// parcialmente conserva saldo FIFO y debe contar/mostrarse; la exclusión de las pagadas la
// hace el FIFO (ausencia del key en saldosPorFacturaMap). Excluye: históricas pre-corte, NC
// (tipo_dte=61, regla 10.42), caja chica (10.39), comisiones factoring/recepción neteadas
// (10.80/10.81), mora saldada por neteo, y facturas saldadas al 100% por el ledger FIFO.
//
// Los sets y el map se reciben por parámetro (cada consumidor ya los tiene armados con SU
// data): la función es pura y no importa nada. saldosPorFacturaMap está keyed "SII:{id}".
export const facturaSiiPorPagar = (
  f,
  { cajaChicaFacturaIds, facturasComisionFactoringSet, facturasMoraNeteadaSet, saldosPorFacturaMap, FECHA_CORTE }
) => {
  if (f.fecha_emision && f.fecha_emision < FECHA_CORTE) return false;
  if (f.tipo_dte === 61) return false;
  if (cajaChicaFacturaIds.has(f.id)) return false;
  if (facturasComisionFactoringSet.has(f.id)) return false;
  // Mora saldada por neteo: el DTE se descontó del giro de una op posterior, sin débito
  // bancario → el FIFO la deja viva. Gate ANTES del check de proveedor_id (estas facturas
  // tienen proveedor_id y si no, caerían en el FIFO y seguirían apareciendo).
  if (facturasMoraNeteadaSet.has(f.id)) return false;
  // Con proveedor_id: ausente del map FIFO = saldada al 100% → excluir. Sin proveedor_id
  // no hay FIFO → se asume monto total pendiente, siempre incluye.
  if (f.proveedor_id) return saldosPorFacturaMap.get(`SII:${f.id}`) !== undefined;
  return true;
};
